import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    btn: {
      justifyContent: 'space-between!important',
      padding: '0 12% 0 8%!important',
      width: '100%',
      margin: '20px 0 0 0!important',
    },

    gridModalTop: {
      borderTopRightRadius: 16,
      borderTopLeftRadius: 16,
      marginTop: '-2px!important',
      backgroundColor: '#a51713',
      textTransform: 'uppercase',
      color: '#fff!important',
      marginBottom: '10px!important',
    },

    titleModal: {
      textTransform: 'uppercase',
      margin: '10px 0 0px 0!important',
      width: '100%',
      justifyContent: 'center',
      fontSize: '15px!important',

      textAlign: 'center',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '5px!important',
      fontSize: '13px!important',
      margin: '0px 0!important',
      color: '#444',
    },
    iconModal: {
      width: 40,
      height: 40,
    },
    btnModal: {
      margin: '10px 0 4px 0!important',
      backgroundColor: '#a51713!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      color: '#fff!important',
      borderRadius: '10px!important',
    },
    btnModalSegund: {
      margin: '4px 0!important',
      color: '#75605d!important',
      backgroundColor: '#fbd3d3!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    btnModalWhite: {
      margin: '4px 0!important',
      border: 'solid 1px #d5c9c9!important',
      color: '#000!important',
      backgroundColor: '#fff!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '100%',
      borderRadius: '10px!important',
    },
    contentModal: {
      marginBottom: '-19px!important',
    },
    titleModalRv: {
      zIndex: 2,
      backgroundColor: '#a51614',
      textTransform: 'uppercase',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },
    gridNameModal: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',
      justifyContent: 'space-between!important',
      borderBottom: 'solid 1px #0000001a',
    },
    nameModal: {
      textTransform: 'uppercase',
      margin: 0,
      color: '#4d5055',
      fontSize: '16px!important',
      textAlign: 'center',
    },

    gridTitleSegund: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 0px!important',
      justifyContent: 'space-between!important',
    },
    titleSegund: {
      margin: 0,
      color: '#4d5055',
      fontSize: 15,
      textAlign: 'center',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 10px!important',
      height: '3.5em!important',
      width: '100%',
    },
    inputTextModal: {
      margin: '5px 0!important',
      padding: '6px 35px!important',
      width: '85%',
      backgroundColor: '#fef0ef',
    },
    labelText: {
      fontSize: 12,
      textAlign: 'left',
      marginTop: 5,
      fontWeight: 550,
      width: '100%',
      color: '#a51713',
    },
    content: {
      marginBottom: '-19px!important',
    },
    title: {
      zIndex: 2,
      backgroundColor: '#a51614',
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },
    textBtnKeepShopping: {
      color: '#292d32',
      margin: '0px 0!important',
    },
    btnCloseX: {
      right: 0,
      float: 'right',
      width: '35px!important',
      height: '35px!important',
      borderRadius: '18px!important',
      background: '#a51614!important',
      color: '#FFF!important',
      marginRight: 10,
      fontWeight: 700,
    },
    girdImgBackground: {
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain' /* ou cover */,
      backgroundPosition: 'center',
      height: 270,
      marginTop: 10,
    },
    titleModalWhite: {
      textTransform: 'uppercase',
      margin: '40px 0 0px 0!important',
      width: '55%',
      justifyContent: 'center',
      fontSize: '15px!important',
      color: '#fff',
      textAlign: 'center',
    },
    textModalWhite: {
      textAlign: 'center',
      margin: '15px 0 0px 0!important',
      fontSize: '13px!important',
      width: '60%',
      [theme.breakpoints.up('sm')]: {
        width: '48%',
      },
      color: '#fff',
    },
    btnModalYellow: {
      margin: '15px 0 0px 0!important',
      backgroundColor: '#f6bc08!important',
      bottom: '0px!important',
      maxWidth: 680,
      width: '30%',
      borderRadius: '10px!important',
      border: 'solid 1px #FC7509',
      [theme.breakpoints.up('sm')]: {
        width: '20%',
      },
      [theme.breakpoints.down('xs')]: {
        width: '30%',
      },
    },

    icon: {
      width: 20,
      height: 20,
      marginLeft: 10,
      marginTop: 25,
      position: 'absolute',
    },

    form: {
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
      marginBottom: 50,
    },

    inputTextOrderData: {
      margin: '2px 0!important',
      padding: '6px 35px!important',
      height: '3.2em!important',
      width: '100%',
    },

    gridInputTextOrderData: {
      borderColor: '#fbedec!important',
      backgroundColor: '#ffffff',
      border: '1px solid',
      borderRadius: '10px!important',
      padding: '6px 15px!important',
      margin: '2px 0!important',
      height: '3.2em!important',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    iconArrow: {
      marginLeft: 10,
    },

    btnLink: {
      color: '#0689f3 !important',
      margin: '0px 0 !important',
      maxWidth: 680,
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
      textTransform: 'capitalize',
      padding: '0px 16px !important',
    },

    inputTextOrderDataAddress: {
      margin: '2px 0!important',
      padding: '6px 15px!important',
      height: '3.2em!important',
      width: '100%',
    },
  }),
);

export default useStyles;
